/**
 * @generated SignedSource<<e7d2bbc095211b279124a75bd20ec4b7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "after"
  },
  {
    "defaultValue": 8,
    "kind": "LocalArgument",
    "name": "first"
  },
  {
    "defaultValue": false,
    "kind": "LocalArgument",
    "name": "includeIsAuthorized"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "postId"
  }
],
v1 = {
  "kind": "Variable",
  "name": "after",
  "variableName": "after"
},
v2 = {
  "kind": "Variable",
  "name": "first",
  "variableName": "first"
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = [
  (v1/*: any*/),
  (v2/*: any*/)
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "media",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "created",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "removed",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "spam",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "likesCount",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "likedByCurrentUser",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "stemLikedByCurrentUser",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewedByCurrentUser",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "commentedByCurrentUser",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "quotedByCurrentUser",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "stemLikesCount",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewsCount",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "quotesCount",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "commentsCount",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sharesCount",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "author",
  "plural": false,
  "selections": [
    (v3/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Vibe",
      "kind": "LinkedField",
      "name": "vibe",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "username",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "condition": "includeIsAuthorized",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "followingUser",
          "storageKey": null
        }
      ]
    }
  ],
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "concreteType": "VibePoll",
  "kind": "LinkedField",
  "name": "poll",
  "plural": false,
  "selections": [
    (v3/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "options",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "optionVotesCounts",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "pollVotesCount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "votedByCurrentUser",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "votedOptionIndex",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CommentsListRefetchQuery",
    "selections": [
      {
        "args": [
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "kind": "Variable",
            "name": "includeIsAuthorized",
            "variableName": "includeIsAuthorized"
          },
          {
            "kind": "Variable",
            "name": "postId",
            "variableName": "postId"
          }
        ],
        "kind": "FragmentSpread",
        "name": "commentsList_query"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CommentsListRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "id",
            "variableName": "postId"
          }
        ],
        "concreteType": "VibePost",
        "kind": "LinkedField",
        "name": "vibePostById",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": (v4/*: any*/),
            "concreteType": "VibePostConnection",
            "kind": "LinkedField",
            "name": "comments",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "VibePostEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "VibePost",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      (v5/*: any*/),
                      (v6/*: any*/),
                      (v7/*: any*/),
                      (v8/*: any*/),
                      (v9/*: any*/),
                      (v10/*: any*/),
                      {
                        "condition": "includeIsAuthorized",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          (v11/*: any*/),
                          (v12/*: any*/),
                          (v13/*: any*/),
                          (v14/*: any*/),
                          (v15/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "sharedByCurrentUser",
                            "storageKey": null
                          }
                        ]
                      },
                      (v16/*: any*/),
                      (v17/*: any*/),
                      (v18/*: any*/),
                      (v19/*: any*/),
                      (v20/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "VibePost",
                        "kind": "LinkedField",
                        "name": "sharedPost",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          (v5/*: any*/),
                          (v6/*: any*/),
                          (v7/*: any*/),
                          (v8/*: any*/),
                          (v9/*: any*/),
                          (v20/*: any*/),
                          (v10/*: any*/),
                          {
                            "condition": "includeIsAuthorized",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                              (v11/*: any*/),
                              (v12/*: any*/),
                              (v13/*: any*/),
                              (v14/*: any*/),
                              (v15/*: any*/)
                            ]
                          },
                          (v16/*: any*/),
                          (v17/*: any*/),
                          (v19/*: any*/),
                          (v18/*: any*/),
                          (v21/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v22/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "VibePost",
                        "kind": "LinkedField",
                        "name": "quotedPost",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          (v5/*: any*/),
                          (v6/*: any*/),
                          (v7/*: any*/),
                          (v8/*: any*/),
                          (v9/*: any*/),
                          (v20/*: any*/),
                          (v10/*: any*/),
                          {
                            "condition": "includeIsAuthorized",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                              (v11/*: any*/),
                              (v12/*: any*/),
                              (v13/*: any*/),
                              (v15/*: any*/)
                            ]
                          },
                          (v16/*: any*/),
                          (v17/*: any*/),
                          (v18/*: any*/),
                          (v22/*: any*/),
                          (v21/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v21/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "__typename",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "cursor",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasNextPage",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "endCursor",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v4/*: any*/),
            "filters": null,
            "handle": "connection",
            "key": "CommentsList_comments",
            "kind": "LinkedHandle",
            "name": "comments"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "acc728cc3054fba44c4311dccb1a942b",
    "id": null,
    "metadata": {},
    "name": "CommentsListRefetchQuery",
    "operationKind": "query",
    "text": "query CommentsListRefetchQuery(\n  $after: String\n  $first: Int = 8\n  $includeIsAuthorized: Boolean = false\n  $postId: String!\n) {\n  ...commentsList_query_4hSDbI\n}\n\nfragment commentsList_query_4hSDbI on Query {\n  vibePostById(id: $postId) {\n    id\n    comments(first: $first, after: $after) {\n      edges {\n        node {\n          id\n          message\n          media\n          created\n          removed\n          spam\n          likesCount\n          likedByCurrentUser @include(if: $includeIsAuthorized)\n          stemLikedByCurrentUser @include(if: $includeIsAuthorized)\n          viewedByCurrentUser @include(if: $includeIsAuthorized)\n          commentedByCurrentUser @include(if: $includeIsAuthorized)\n          quotedByCurrentUser @include(if: $includeIsAuthorized)\n          sharedByCurrentUser @include(if: $includeIsAuthorized)\n          stemLikesCount\n          viewsCount\n          quotesCount\n          commentsCount\n          sharesCount\n          sharedPost {\n            id\n            message\n            media\n            created\n            removed\n            spam\n            sharesCount\n            likesCount\n            likedByCurrentUser @include(if: $includeIsAuthorized)\n            stemLikedByCurrentUser @include(if: $includeIsAuthorized)\n            viewedByCurrentUser @include(if: $includeIsAuthorized)\n            commentedByCurrentUser @include(if: $includeIsAuthorized)\n            quotedByCurrentUser @include(if: $includeIsAuthorized)\n            stemLikesCount\n            viewsCount\n            commentsCount\n            quotesCount\n            author {\n              id\n              vibe {\n                username\n              }\n              followingUser @include(if: $includeIsAuthorized)\n            }\n          }\n          poll {\n            id\n            options\n            optionVotesCounts\n            pollVotesCount\n            votedByCurrentUser\n            votedOptionIndex\n          }\n          quotedPost {\n            id\n            message\n            media\n            created\n            removed\n            spam\n            sharesCount\n            likesCount\n            likedByCurrentUser @include(if: $includeIsAuthorized)\n            stemLikedByCurrentUser @include(if: $includeIsAuthorized)\n            viewedByCurrentUser @include(if: $includeIsAuthorized)\n            quotedByCurrentUser @include(if: $includeIsAuthorized)\n            stemLikesCount\n            viewsCount\n            quotesCount\n            poll {\n              id\n              options\n              optionVotesCounts\n              pollVotesCount\n              votedByCurrentUser\n              votedOptionIndex\n            }\n            author {\n              id\n              vibe {\n                username\n              }\n              followingUser @include(if: $includeIsAuthorized)\n            }\n          }\n          author {\n            id\n            vibe {\n              username\n            }\n            followingUser @include(if: $includeIsAuthorized)\n          }\n          __typename\n        }\n        cursor\n      }\n      pageInfo {\n        hasNextPage\n        endCursor\n      }\n    }\n  }\n}\n"
  }
};
})();

node.hash = "b2151642b8af3fd37f6acee930d192c4";

module.exports = node;
